import { render, staticRenderFns } from "./BusinessCreditApplication.vue?vue&type=template&id=61ea324a&scoped=true&"
import script from "./BusinessCreditApplication.vue?vue&type=script&lang=js&"
export * from "./BusinessCreditApplication.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCreditApplication.vue?vue&type=style&index=0&id=61ea324a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ea324a",
  null
  
)

export default component.exports